<template>
    <!-- Start Main Content -->
    <div
        class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">

        <!-- Add notice form -->
        <div class="card p-4 lg:p-6">
            <h6 class="card-title">Add Opening Stock</h6>
            <form>
                <div class="grid grid-cols-12 gap-x-4 gap-y-5 mt-7 pt-0.5" v-on:keyup.enter="nextFocus">
                    <div class="col-span-full  lg:col-span-4 leading-none">
                        <label class="form-label">Product *</label>
                        <select class="form-input" v-model="openingstock.product">
                            <option DISABLED value="0">SELECT Product</option>
                            <option v-for="(item, index)  in prdList" :value="item.id">{{ item.name }}</option>
                        </select>
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Purchase Rate *</label>
                        <input type="number" id="barcode" v-model="openingstock.purchaserate" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Manufacturing  Date *</label>
                        <input type="date" id="barcode" v-model="openingstock.manufacturingdate" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Expiry  Date *</label>
                        <input type="date" id="barcode" v-model="openingstock.expirydate" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>

                    <div class="col-span-full lg:col-span-4 leading-none">
                        <label for="" class="form-label">Batch No *</label>
                        <input type="number" id="barcode" v-model="openingstock.batchno" placeholder="Type Here"
                            class="form-input" required autocomplete="off">
                    </div>
                </div>
            </form>
            <button @click="save" id="saveBtn" class="btn b-solid btn-primary-solid px-5 cursor-pointer mt-6">
                Add Opening Stock
            </button>

        </div>
    </div>



</template>

<script>
// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue'
import axios from 'axios';

export default {
    name: 'AddOpening Stock',
    components: {

    },
    mounted() {
        this.getBasics();
        $(".form-input").on('keyup')
    },
    data() {
        return {
            isAdd: 0,
            isEdit: 0,
            isDelete: 0,
            deleteId: 0,
            percent:40,
            prdList: [],
            openingstock: { 
                product: '',purchaserate:'',manufacturingdate:'',expirydate:'',batchno:''},
        }
    },
    methods: {
        async getBasics() {
            var self = this;
            axios.post('getProducts').then(function (response) {
                self.prdList = response.data.products;
                console.log(self.prdList);
            });
        },
        nextFocus(e) {
            const inputs = Array.from(e.target.form.querySelectorAll('input'));
            const index = inputs.indexOf(e.target);

            if (index < inputs.length) {
                try {
                    inputs[index + 1].focus();
                    inputs[index + 1].select();
                } catch (error) {
                    $("#saveBtn").focus();
                }
            }
        },
        cal_saleprice(){
         
              this.product.salerate=(parseFloat(this.product.prate)+(parseFloat(this.product.prate) * ((parseFloat(this.percent)/100)))).toFixed(0);
           
        },
        save() {
            var self = this;
            if (self.openingstock.product == '') 
                self.$swal("Product Name is Required");
            else {
                self.$swal({
                    title: "Do You Want To Save?",
                    text: "Are you sure? ",
                    type: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    confirmButtonText: "Yes"
                }).then((result) => { // <--
                    if (result.value) { // <-- if confirmed
                        axios.post('addOpeningstock', this.openingstock)
                            .then(response => {
                                var msg = response.data.msg;
                                var isSuccess = response.data.status;
                                self.prdList = response.data.products;
                                if (isSuccess == 1) {
                                    self.openingstock = { 
                                        product: '',purchaserate:'',manufacturingdate:'',expirydate:'',batchno:''}
                                }


                                self.$swal(msg);

                            })
                            .catch(error => {
                                console.log('Error on Authentication: ' + error);
                            });
                    }
                });
            }

        }
    }
}
</script>
